<div class="container-fluid animation-fadein" [ngClass]="rootClassName">
  <div class="form-step">
    <div class="row d-flex">
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
    </div>
    <div class="row d-flex">
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Cotizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Customizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Contacto</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pago</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Certificado</span>
      </div>
    </div>
  </div>
  <div class="stup-10-section-wrap">
    <div class="form-left-section form-itams">
      <img [attr.alt]="ballPink1srcNew" [attr.src]="ballPink1srcNew" class="img-fluid style-img-basketball" />
    </div>
  <div class="stup-10-section mb-4">
    <div class="stups-accordion">
      <form [formGroup]="stepElevenForm" >
        <div formArrayName="rows65">
          <p-accordion class="w-full">
            <p-accordionTab *ngFor="let row of rows65.controls; let i = index" [formGroupName]="i" [class.plan-added]="row.value.pasaportNo">
              <ng-template pTemplate="header">
                <div class="d-flex justify-content-between w-100">
                  <span class="text-white-short-style d-flex align-items-center mobile-none" style="font-weight: normal !important;">Añadir información de dependiente de
                    más <span class="blue-text hellper" style="display: block !important;">{{" "}}+65 años</span></span>
                  <span class="text-white-short-style web-none" style="font-weight: normal !important;">Añadir información de dependiente de
                      más <span class="blue-text-d-none">{{" "}}+65 años</span></span>
                  <span class="blue-text">{{ row.value.pasaportNo ? 'Añadido' : 'Añadir' }} 
                    <img src="/assets/external/gray-minas.svg" alt="open">
                     
                  </span>
                </div>
              </ng-template>
              <div class="p-style-accordion">
                <div class="form-section">
                  <form novalidate class="p-4 form-general-style">
                    <div class="row formControlRow date mb-16px">
                      <div class="dateFormControlContainer col form-small-label">
                        <app-input-field [formGroup]="row" controlName="dayBirth" id="díaNacimiento"
                          label="Día Nacimiento" [submitted]="row.value.isSubmitted"
                          errorMessage="Día Nacimiento"
                          minMaxErrorMessage="El dia debe estar entre 1 y 31."
                          ></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Día Nacimiento"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Día Nacimiento</label>
                    </div> -->
                      </div>
                      <div class="dateFormControlContainer col form-small-label">
                        <app-input-field [formGroup]="row" controlName="monthBirth" id="mesNacimiento"
                          label="Mes Nacimiento" [submitted]="row.value.isSubmitted"
                          errorMessage="Mes Nacimiento"
                          minMaxErrorMessage="El mes debe estar entre 1 y 12."
                          ></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Mes Nacimiento"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Mes Nacimiento</label>
                    </div> -->
                      </div>
                      <div class="dateFormControlContainer col form-small-label">
                        <app-input-field [formGroup]="row" controlName="yearBirth" id="añoNacimiento"
                          label="Año Nacimiento" [submitted]="row.value.isSubmitted"
                          errorMessage="Año Nacimiento"
                          minMaxErrorMessage="El año debe estar entre 1900 y 2025."
                          ></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Año Nacimiento"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Año Nacimiento</label>
                    </div> -->
                      </div>
                    </div>
                    <div class="row formControlRow mb-16px">
                      <div class="formControlContainer col-12 col-md-6">
                        <app-input-field [formGroup]="row" controlName="firstName" id="primerNombre"
                          label="Primer Nombre" [submitted]="row.value.isSubmitted" errorMessage="Primer Nombre"></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Primer Nombre"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Primer Nombre</label>
                    </div> -->
                      </div>
                      <div class="formControlContainer col-12 col-md-6">
                        <app-input-field [formGroup]="row" controlName="lastName" id="apellidosDelTitular"
                          label="Apellidos del Titular" [submitted]="row.value.isSubmitted"
                          errorMessage="Apellidos del Titular"></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Apellidos del Titular"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Apellidos del Titular</label>
                    </div> -->
                      </div>
                    </div>
                    <div class="row formControlRow mb-16px">
                      <div class="formControlContainer col-12 col-md-6">
                        <app-input-field [formGroup]="row" controlName="pasaportNo" id="pasaporteNoCédula"
                          label="Pasaporte o No Cédula" [submitted]="row.value.isSubmitted"
                          errorMessage="Pasaporte o No Cédula"></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Pasaporte o No Cédula"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Pasaporte o No Cédula</label>
                    </div> -->
                      </div>
                      <div class="formControlContainer col-12 col-md-6">
                        <app-input-field [formGroup]="row" controlName="relationship" id="Relación" label="Relación"
                          [submitted]="row.value.isSubmitted" errorMessage="Relación"></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Relación"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Relación</label>
                    </div> -->
                      </div>
                    </div>
                    <!-- <div class="row dob-section">
                    </div> -->

                    <div class="" *ngIf="row.value.isError65">
                      <div class="alert alert-danger">
                        <span class="text-danger">El titular debe ser mayor de 65 años</span>
                      </div>
                    </div>
                    <div class="form-group mb-0">
                      <button type="button" (click)="submitDependent(i, true)" class="continue-btn-steps btn-transparent py-3" [disabled]="row.value.isLoading">
                        {{
                          row.value.isLoading ? 'Cargando...' : 'Añadir Dependiente'
                        }}
                        </button>
                    </div>
                  </form>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
        </div>
      </form>
      <form [formGroup]="stepTenForm" >
        <div formArrayName="rows">
          <p-accordion class="w-full">
            <p-accordionTab *ngFor="let row of rows.controls; let i = index" [formGroupName]="i" [formGroupName]="i" [class.plan-added]="row.value.pasaportNo">
              <ng-template pTemplate="header">
                <div class="d-flex justify-content-between w-100">
                  <span class="text-white-short-style d-flex align-items-center mobile-none" style="font-weight: normal !important;">Añadir información de dependiente  
                    <span class="blue-text hellper" style="display: block !important;">{{" "}}Num {{ i + 1 }}</span>
                   </span>
                   <span class="text-white-short-style web-none" style="font-weight: normal !important;">Añadir información de dependiente de
                    más <span class="blue-text-d-none">{{" "}}Num {{ i + 1 }}</span></span>
                  <span class="blue-text">{{ row.value.pasaportNo ? 'Añadido' : 'Añadir' }} 
                    <img src="/assets/external/gray-minas.svg" alt="open">
                  </span>
                </div>
              </ng-template>
              <div class="p-style-accordion">
                <div class="form-section">
                  <form novalidate class="p-4 form-general-style">
                    <div class="row formControlRow date mb-16px">
                      <div class="dateFormControlContainer col form-small-label">
                        <app-input-field [formGroup]="row" controlName="dayBirth" id="díaNacimiento"
                          label="Día Nacimiento" [submitted]="row.value.isSubmitted"
                          errorMessage="Día Nacimiento"
                          minMaxErrorMessage="El día debe estar entre 1 y 31."
                          ></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Día Nacimiento"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Día Nacimiento</label>
                    </div> -->
                      </div>
                      <div class="dateFormControlContainer col form-small-label">
                        <app-input-field [formGroup]="row" controlName="monthBirth" id="mesNacimiento"
                          label="Mes Nacimiento" [submitted]="row.value.isSubmitted"
                          errorMessage="Mes Nacimiento"
                          minMaxErrorMessage="El mes debe estar entre 1 y 12."
                          ></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Mes Nacimiento"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Mes Nacimiento</label>
                    </div> -->
                      </div>
                      <div class="dateFormControlContainer col form-small-label">
                        <app-input-field [formGroup]="row" controlName="yearBirth" id="añoNacimiento"
                          label="Año Nacimiento" [submitted]="row.value.isSubmitted"
                          errorMessage="Año Nacimiento"
                          minMaxErrorMessage="El año debe estar entre 1900 y 2025."
                          ></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Año Nacimiento"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Año Nacimiento</label>
                    </div> -->
                      </div>
                    </div>
                    <div class="row formControlRow mb-16px">
                      <div class="formControlContainer col-md-6">
                        <app-input-field [formGroup]="row" controlName="firstName" id="primerNombre"
                          label="Primer Nombre" [submitted]="row.value.isSubmitted" errorMessage="Primer Nombre"></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Primer Nombre"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Primer Nombre</label>
                    </div> -->
                      </div>
                      <div class="formControlContainer col-md-6">
                        <app-input-field [formGroup]="row" controlName="lastName" id="apellidosDelTitular"
                          label="Apellidos del Titular" [submitted]="row.value.isSubmitted"
                          errorMessage="Apellidos del Titular"></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Apellidos del Titular"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Apellidos del Titular</label>
                    </div> -->
                      </div>
                    </div>
                    <div class="row formControlRow mb-16px">
                      <div class="formControlContainer col-md-6">
                        <app-input-field [formGroup]="row" controlName="pasaportNo" id="pasaporteNoCédula"
                          label="Pasaporte o No Cédula" [submitted]="row.value.isSubmitted"
                          errorMessage="Pasaporte o No Cédula"></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Pasaporte o No Cédula"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Pasaporte o No Cédula</label>
                    </div> -->
                      </div>
                      <div class="formControlContainer col-md-6">
                        <app-input-field [formGroup]="row" controlName="relationship" id="Relación" label="Relación"
                          [submitted]="row.value.isSubmitted" errorMessage="Relación"></app-input-field>
                        <!-- <div class="form-group">
                      <input type="text" class="form-control form-input input-form-full-space" formControlName="Relación"
                        onclick="this.setAttribute('value', this.value);" value="">
                      <label for="firstName" class="form-input-label">Relación</label>
                    </div> -->
                      </div>
                    </div>
                    <!-- <div class="row dob-section">
                    </div> -->

                    <div class="" *ngIf="row.value.isError65">
                      <div class="alert alert-danger">
                        <span class="text-danger">El dependiente debe ser menor de 65 años</span>
                      </div>
                    </div>
                    <div class="form-group mb-0">
                      <button type="button" (click)="submitDependent(i, false)"  class="continue-btn-steps btn-transparent py-3" [disabled]="row.value.isLoading">
                        {{
                          row.value.isLoading ? 'Cargando...' : 'Añadir Dependiente'
                        }}
                        
                        
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
        </div>
        
      </form>
      <div class="text-danger"
          *ngIf="allSubmitted">
          <label class="feld-error label-form-style d-flex pl-2 pb-4" style="color: #E40052; font-weight: 500;">
            <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
            Agregar todos los detalles del miembro. 
          </label>
        </div>
      <div class="form-group mb-0">
        <button type="button" (click)="submitForm()"  class="continue-btn-steps py-3"
        
        >Continuar Activación</button>
      </div>
    </div>
  
  </div>
  <div class="form-right-section form-itams">
    <img [attr.alt]="towerNew" [attr.src]="towerNew" class="img-fluid style-img-tower" />
  </div>
  <a href="javascript:void(0)" (click)="prevStep()" class="back-link">
    < Atrás</a>
  <div class="copy-right">
    <p>All rights reserved by BAC Financial Services. | Política de privacidad | Design by <a href="https://www.wemarkforyou.com" target="_blank">www.wemarkforyou.com</a>. </p>
    <h5>Politica de privacidad</h5>
  </div>
</div>
</div>

<!-- <div class="quote-step11-quote-step5-2 animation-fadein" [ngClass]="rootClassName">
  <div class="quote-step11-container">
    <span class="quote-step11-text DesK,P4,Regular,16">
      <span>
        Por favor, proporcione la información requerida para el dependiente
        elegible, en caso de que aplique.
      </span>
    </span>
    <div class="quote-step11-frame566">
      <div class="quote-step11-frame274">
        <div class="quote-step11-frame1095 form-group">
          <div class="quote-step11-frame168">
            <div class="quote-step11-frame165">
              <span class="quote-step11-text02 Desk,P4,Bold.14">
                <span>Relación</span>
              </span>
            </div>
            <div class="quote-step11-frame169">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder"
                class="quote-step11-input"
              />
            </div>
          </div>
          <div class="quote-step11-frame174">
            <div class="quote-step11-frame1651">
              <span class="quote-step11-text04 Desk,P4,Bold.14">
                <span>Fecha de Nacimimiento</span>
              </span>
            </div>
            <div class="quote-step11-frame1691">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder1"
                class="quote-step11-input1"
              />
            </div>
          </div>
        </div>
        <div class="quote-step11-frame1101 form-group">
          <div class="quote-step11-frame1681">
            <div class="quote-step11-frame1652">
              <span class="quote-step11-text06 Desk,P4,Bold.14">
                <span>Primer Nombre</span>
              </span>
            </div>
            <div class="quote-dropdown">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder2"
                class="quote-step11-input2"
              />
            </div>
          </div>
          <div class="quote-step11-frame1741">
            <div class="quote-step11-frame1653">
              <span class="quote-step11-text08 Desk,P4,Bold.14">
                <span>Apellidos</span>
              </span>
            </div>
            <div class="quote-step11-frame1693">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder3"
                class="quote-step11-input3"
              />
            </div>
          </div>
        </div>
        <div class="quote-step11-frame1097 form-group">
          <div class="quote-step11-frame1682">
            <div class="quote-step11-frame1654">
              <span class="quote-step11-text10 Desk,P4,Bold.14">
                <span>Pasaporte o Cédula de identificación</span>
              </span>
            </div>
            <div class="quote-step11-frame1694">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder4"
                class="quote-step11-input4"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="quote-step11-frame478">
      <button class="quote-step11-frame275" (click)="nextStep()">
        <span class="quote-step11-text12 Desk,P4,Bold.14">
          <span>Continuar Activación</span>
        </span>
      </button>
      <button class="quote-step11-text14 DesK,P4,Regular,16" (click)="prevStep()">
        <span>&lt; Paso anterior</span>
      </button>
    </div>
    <div class="quote-step11-frame456">
      <span class="quote-step11-text16 Mob,P4,Intro,Light,10">
        <span>Cotizar</span>
      </span>
      <span class="quote-step11-text18 Mob,P4,Intro,Light,10">
        <span>Customizar</span>
      </span>
      <span class="quote-step11-text20 Mob,P4,Intro,Light,10">
        <span>Contacto</span>
      </span>
      <span class="quote-step11-text22 Mob,P4,Intro,Light,10">
        <span>Pago</span>
      </span>
      <span class="quote-step11-text24 Mob,P6-Intro-Bold">
        <span>Certificado</span>
      </span>
      <div class="quote-step11-progressbar"></div>
      <div class="quote-step11-progressbar1"></div>
      <div class="quote-step11-progressbar2"></div>
      <img
        [attr.alt]="ellipse25alt"
        [attr.src]="ellipse25src"
        class="quote-step11-ellipse25"
      />
      <img
        [attr.alt]="vectoralt"
        [attr.src]="vectorsrc"
        class="quote-step11-vector"
      />
      <img
        [attr.alt]="ellipse25alt1"
        [attr.src]="ellipse25src1"
        class="quote-step11-ellipse251"
      />
      <img
        [attr.alt]="vectoralt1"
        [attr.src]="vectorsrc1"
        class="quote-step11-vector1"
      />
      <img
        [attr.alt]="ellipse25alt2"
        [attr.src]="ellipse25src2"
        class="quote-step11-ellipse252"
      />
      <img
        [attr.alt]="vectoralt2"
        [attr.src]="vectorsrc2"
        class="quote-step11-vector2"
      />
      <img
        [attr.alt]="ellipse25alt3"
        [attr.src]="ellipse25src3"
        class="quote-step11-ellipse253"
      />
      <img
        [attr.alt]="vectoralt3"
        [attr.src]="vectorsrc3"
        class="quote-step11-vector3"
      />
      <img
        [attr.alt]="ellipse25alt4"
        [attr.src]="ellipse25src4"
        class="quote-step11-ellipse254"
      />
      <img
        [attr.alt]="vectoralt4"
        [attr.src]="vectorsrc4"
        class="quote-step11-vector4"
      />
    </div>
  </div>
</div> -->